import { render, staticRenderFns } from "./temp.vue?vue&type=template&id=65db2fd0&scoped=true"
import script from "./temp.vue?vue&type=script&lang=js"
export * from "./temp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db2fd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65db2fd0')) {
      api.createRecord('65db2fd0', component.options)
    } else {
      api.reload('65db2fd0', component.options)
    }
    module.hot.accept("./temp.vue?vue&type=template&id=65db2fd0&scoped=true", function () {
      api.rerender('65db2fd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wx/temp.vue"
export default component.exports